import { $ } from '@starberry/components';
import { Heading } from '@chakra-ui/react';

export default {
    Heading: {
        component: Heading,
        props: $('constants.headings.baseHeading'),
    },

    H1: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h1'),
            lineHeight: $('constants.headings.headingLineHeight.h1'),
        },
    },

    H2: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h2'),
            lineHeight: $('constants.headings.headingLineHeight.h2'),
        }
    },

    H3: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h3'),
            lineHeight: $('constants.headings.headingLineHeight.h3'),
        }
    },

    H4: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h4'),
            lineHeight: $('constants.headings.headingLineHeight.h4'),
        }
    },

    H5: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h5'),
            lineHeight: $('constants.headings.headingLineHeight.h5'),
        }
    },

    H6: {
        $: 'Heading',
        props: {
            fontSize: $('constants.headings.headingSize.h6'),
            lineHeight: $('constants.headings.headingLineHeight.h6'),
        }
    },
};